// axios
export const AXIOS_TIMEOUT = 10000;
export const AXIOS_TIMEOUT_ERROR_CODE = "ETIMEDOUT";